<div class="unavailable-page">
  <cigna-icon class="unavailable-icon" type="unavailable"></cigna-icon>
  <h3>Maintenance Notice</h3>
  <p>
    This page is currently unavailable. We are sorry for any inconvenience.
    Please bear with us while we work to correct the issue.
  </p>
</div>
